<template>
  <div>
    <div v-if="display">
      <v-layout row>
        <v-flex class="error-message" v-if="showError">{{ errorMessage }}</v-flex>
        <v-flex xs1 class="buttons mt-0 mb-0 mr-0" v-if="(showError)&&(clearable)">
          <v-layout class="buttons mt-0 mb-0 mr-0" justify-end align-top row>
            <v-btn icon @click="close" class="pa-0 ma-0">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex v-if="!tile">
          <div
            :class="[{'tileHeading':tile}, {'normalHeading':!tile}]"
            v-if="(loaded) && (header.title)"
          >{{ header.title? header.title: "" }}</div>
          <div style="font-size: 15px;" v-if="(loaded)&&(header.submitted)">
            <strong>As Of:</strong>
            {{header.submitted}}
          </div>
          <div style="font-size: 15px;" v-if="(loaded)&&(header.owner)">
            <strong>Owner:</strong>
            {{header.owner}}
          </div>
          <div style="font-size: 15px;" v-if="(loaded)&&(header.dataFrequency)">
            <strong>Frequency:</strong>
            {{header.dataFrequency}}
          </div>
        </v-flex>
        <v-flex v-if="tile" class="pb-2">
          <div
            :class="[{'tileHeading':tile}, {'normalHeading':!tile}]"
            v-if="(loaded) && (header.title)"
          >{{ header.title? header.title: "" }}</div>
          <v-layout row>
            <v-flex style="font-size: 15px;" v-if="(loaded)&&(header.submitted)">
              <strong>As Of:</strong>
              {{header.submitted}}
            </v-flex>
            <v-flex style="font-size: 15px;" v-if="(loaded)&&(header.owner)">
              <strong>Owner:</strong>
              {{header.owner}}
            </v-flex>
            <v-flex style="font-size: 15px;" v-if="(loaded)&&(header.dataFrequency)">
              <strong>Frequency:</strong>
              {{header.dataFrequency}}
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex class="text-xs-right align-center" v-if="loaded" :class="{'pt-2':clearable}">
          <router-link
            style="text-decoration:none"
            :to="openViewDashboard()"
            class="btn btn-default"
            data-html2canvas-ignore="true"
            v-if="tile"
          >
            <span class="hidden-xs hidden-sm mr-3">VIEW</span>
          </router-link>
          <a @click="export2PDF" class="btn btn-default" data-html2canvas-ignore="true">
            <span class="hidden-xs hidden-sm ml5">PDF</span>
          </a>
          <a @click="exportToExcel" class="btn btn-default ml-3" data-html2canvas-ignore="true">
            <span class="hidden-xs hidden-sm ml5">EXCEL</span>
          </a>
        </v-flex>
        <v-flex xs1 class="buttons mt-0 mb-0 mr-0" v-if="(loaded)&&(clearable)">
          <v-layout class="buttons mt-0 mb-0 mr-0" justify-end align-top row>
            <v-btn icon @click="close" class="pa-0 ma-0">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
      <div class="chart-container" :style="cssProps">
        <bar-chart v-if="loaded" :chartdata="chartdata" :options="options" />
      </div>
    </div>

    <!-- Chart To PDF render -->
    <div id="chart2PDF">
      <div class="error-message" v-if="showError">{{ errorMessage }}</div>
      <div>
        <div
          style="font-size: 20px; font-weight: 600;"
          v-if="(loaded) && (header.title)"
        >{{ header.title? header.title: "" }}</div>
        <div style="font-size: 15px;" v-if="(loaded)&&(header.submitted)">
          <strong>As Of:</strong>
          {{header.submitted}}
        </div>
        <div style="font-size: 15px;" v-if="(loaded)&&(header.owner)">
          <strong>Owner:</strong>
          {{header.owner}}
        </div>
        <div style="font-size: 15px;" v-if="(loaded)&&(header.dataFrequency)">
          <strong>Frequency:</strong>
          {{header.dataFrequency}}
        </div>
      </div>
      <div class="pdf-chart-container" id="bar">
        <bar-chart v-if="loaded" :chartdata="chartdata" :options="options" />
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "./BarChart.vue";
import jsPDF from "jspdf";
import * as helper from "../../helpers/global.js";
import moment from "moment";
import axios from "axios";

export default {
  name: "BarChartContainer",
  props: {
    DBID: {
      type: String,
      default: null
    },
    isMounted: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: "calc(100vh - 200px)"
    },
    width: {
      type: String,
      default: "100%"
    },
    clearable: {
      type: Boolean,
      default: false
    },
    tile: {
      type: Boolean,
      default: false
    },
    display: {
      type: Boolean,
      default: true
    }
  },
  components: { BarChart },
  data: () => ({
    errorMessage: "No Data Found",
    chartdata: {},
    header: {},
    options: {},
    loaded: false,
    showError: false
  }),
  async mounted() {
    this.initialize();
  },
  watch: {
    DBID(val) {
      if (val) {
        if (this.isMounted) {
          this.initialize();
        }
      }
    }
    // isMounted(val) {
    //   if (val) {
    //     if (this.DBID) {
    //       this.initialize();
    //     }
    //   }
    // }
  },
  methods: {
    async initialize() {
      if (this.DBID) {
        axios
          .get("/api/Dashboards/viewDashboard/" + this.DBID)
          .then(res => {
            res.data.chartdata ? (this.chartdata = res.data.chartdata) : "";

            // adds 1000 comma seperator for y-axis and tooltip
            // adds $ to currency, % to percentage
            var options;
            res.data.options ? (options = res.data.options) : "";

            //  options.tooltips = {
            //       callbacks: {
            //         footer: function(tooltipItem, data) {
            //           var value = tooltipItem.yLabel

            //             return "$" + value;
            //         }
            //       } // end callbacks:
            //     }; //end tooltips

            options.scales.yAxes.forEach(async el => {
              if (el.ticks.isCurrency) {
                el.ticks.callback = function(value, index, values) {
                  if (parseFloat(value) >= 1000) {
                    return (
                      "$" +
                      value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    );
                  } else {
                    return "$" + value;
                  }
                };

                options.tooltips = {
                  footerFontSize:10,
                  callbacks: {
                    label: function(tooltipItem, data) {
                      var value =
                        data.datasets[tooltipItem.datasetIndex].data[
                          tooltipItem.index
                        ];
                      if (parseFloat(value) >= 1000) {
                        // var parts = value.toString().split(".");
                        // parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        // parts.join(".");
                        // parts = "$" + parts;
                        // return parts;
                        if (value % 2 !== 0) {
                          value = value.toFixed(2);
                        }
                        return (
                          "$" +
                          value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        );
                      } else {
                        return "$" + value;
                      }
                    },
                    footer: function(tooltipItem, data) {
                      var dateTime = data.dateCollected[tooltipItem[0].index];
                      var date = moment(dateTime, "YYYY-MM-DDTHH:mm:ss").format(
                        "YYYY-MMM-DD"
                      );
                      var time = moment(dateTime, "YYYY-MM-DDTHH:mm:ss").format(
                        "h:mm a"
                      );

                      // var label = data.datasets[tooltipItem.datasetIndex].label;
                      // var month = tooltipItem.label;
                      // var year = "";

                      // var matches = label.match(/(\d+)/);
                      // if (matches.length > -1) {
                      //   year = matches[0];
                      // }
                      // var date = month + " " + year;
                      // var time = "";

                      // if (month && year) {
                      //   date = moment(date, "MMMM YYYY")
                      //     .add(1, "month")
                      //     .add(1, "minute")
                      //     .format("YYYY-MMM-DD");

                      //     time = moment(date, "MMMM YYYY")
                      //     .add(1, "month")
                      //     .add(Math.round(Math.random() * 10), "minute")
                      //     .format("h:mm a");

                      // }
                      var value = [" ", date, time];

                      return value;
                    }
                  } // end callbacks:
                }; //end tooltips
              } else if (el.ticks.isPercentage) {
                el.ticks.callback = function(value, index, values) {
                  if (parseFloat(value) >= 1000) {
                    return (
                      value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
                      "%"
                    );
                  } else {
                    return value + "%";
                  }
                };

                options.tooltips = {
                  footerFontSize:10,
                  callbacks: {
                    label: function(tooltipItem, data) {
                      var value =
                        data.datasets[tooltipItem[0].datasetIndex].data[
                          tooltipItem.index
                        ];
                      if (parseFloat(value) >= 1000) {
                        return (
                          value
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "%"
                        );
                      } else {
                        return value + "%";
                      }
                    },
                    footer: function(tooltipItem, data) {
                      var dateTime = data.dateCollected[tooltipItem.index];
                      var date = moment(dateTime, "YYYY-MM-DDTHH:mm:ss").format(
                        "YYYY-MMM-DD"
                      );
                      var time = moment(dateTime, "YYYY-MM-DDTHH:mm:ss").format(
                        "h:mm a"
                      );

                      // var label = data.datasets[tooltipItem.datasetIndex].label;
                      // var month = tooltipItem.label;
                      // var year = "";

                      // var matches = label.match(/(\d+)/);
                      // if (matches.length > -1) {
                      //   year = matches[0];
                      // }
                      // var date = month + " " + year;
                      // var time = "";

                      // if (month && year) {
                      //   date = moment(date, "MMMM YYYY")
                      //     .add(1, "month")
                      //     .add(1, "minute")
                      //     .format("YYYY-MMM-DD");

                      //     time = moment(date, "MMMM YYYY")
                      //     .add(1, "month")
                      //     .add(Math.round(Math.random() * 10), "minute")
                      //     .format("h:mm a");

                      // }
                      var value = [" ", date, time];

                      return value;
                    }
                  } // end callbacks:
                }; //end tooltips
              } else if (el.ticks.isNumber) {
                el.ticks.callback = function(value, index, values) {
                  if (parseFloat(value) >= 1000) {
                    return value
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  } else {
                    return value;
                  }
                };

                options.tooltips = {
                  footerFontSize:10,
                  callbacks: {
                    label: function(tooltipItem, data) {
                      var value =
                        data.datasets[tooltipItem.datasetIndex].data[
                          tooltipItem.index
                        ];
                      if (parseFloat(value) >= 1000) {
                        return value
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                      } else {
                        return value;
                      }
                    },
                    footer: function(tooltipItem, data) {
                      console.log(tooltipItem)
                      console.log(data)
                      var dateTime = data.dateCollected[tooltipItem[0].index];
                      console.log(dateTime)
                      var date = moment(dateTime, "YYYY-MM-DDTHH:mm:ss").format(
                        "YYYY-MMM-DD"
                      );
                      var time = moment(dateTime, "YYYY-MM-DDTHH:mm:ss").format(
                        "h:mm a"
                      );

                      // var label = data.datasets[tooltipItem.datasetIndex].label;
                      // var month = tooltipItem.label;
                      // var year = "";

                      // var matches = label.match(/(\d+)/);
                      // if (matches.length > -1) {
                      //   year = matches[0];
                      // }
                      // var date = month + " " + year;
                      // var time = "";

                      // if (month && year) {
                      //   date = moment(date, "MMMM YYYY")
                      //     .add(1, "month")
                      //     .add(1, "minute")
                      //     .format("YYYY-MMM-DD");

                      //     time = moment(date, "MMMM YYYY")
                      //     .add(1, "month")
                      //     .add(Math.round(Math.random() * 10), "minute")
                      //     .format("h:mm a");

                      // }
                      var value = [" ", date, time];
                      // var value=date.toString()

                      return value;
                    }
                  } // end callbacks:
                }; //end tooltips
              }
            });

            this.options = options;

            res.data.header ? (this.header = res.data.header) : "";
          })
          .then(() => {
            this.loaded = true;
          })
          .catch(err => {
            this.showError = true;
          });
      }
      // axios
      // .get("/api/Dashboards/test/" + this.DBID)
      // .then(res => {
      //   console.log(res.data)
      // })
      // .catch(err => {
      //   // this.showError = true;
      //   console.log(err)
      // });
    },
    async export2PDF() {
      var currentDate = moment().format("YYYYMMDD.HHmm");
      const doc = await helper.renderPDF(1440, 1080, "chart2PDF", "l");
      var title;
      this.header.title
        ? (title = this.header.title + "." + currentDate + ".pdf")
        : (title = "download.pdf");
      await doc.save(title);
      return true;
    },
    exportToExcel(item) {
      axios({
        url: "/api/Dashboards/dashboardtoexcel/" + this.DBID,
        method: "POST",
        responseType: "blob"
      })
        .then(response => {
          var currentDate = moment().format("YYYYMMDD.HHmm");
          var fileName;
          this.header.title
            ? (fileName = this.header.title + "." + currentDate + ".xlsx")
            : (fileName = "dashboard.xlsx");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
          // this.$refs.spinner.spinOff();
        })
        .catch(err => {
          // this.$refs.spinner.spinOff();
        });
    },
    close() {
      this.$emit("close", this.DBID);
    },
    openViewDashboard() {
      return "/dashboard-view/" + this.DBID;
    }
  },
  computed: {
    cssProps() {
      var height = this.height;
      var width = this.width;

      var cssProps = {
        "--height": height,
        "--width": width
      };
      return cssProps;
    }
  }
};
</script>
<style lang="scss" scoped>
.chart-container {
  flex-grow: 1;
  min-height: 0;
  // height:80vh;
  // height: calc(100vh - 200px);
  height: var(--height);
  width: var(--width);
  > div {
    position: relative;
    height: 100%;
  }
}
.pdf-chart-container {
  flex-grow: 1;
  min-height: 880px;
  height: 880px;
  width: 1440px;
  width: 1440px;

  > div {
    position: relative;
    height: 100%;
  }
}
#chart2PDF {
  position: absolute;
  top: -9999px;
  left: -9999px;
}
.tileHeading {
  font-size: 18px;
  font-weight: 600;
}
.normalHeading {
  font-size: 20px;
  font-weight: 600;
}
</style>

